export default "/images/f35cebac258011fe710dc7440dad730e.avif";